module.exports = __webpack_public_path__ + "static/videoPoster-8b3439e81b9d66e4e5af345ca11a0e4d.webp";